const forms = {
  required: 'Campo obrigatório',
  invalid: 'Valor inválido',
  validation: {
    phoneInvalid: 'Telefone inválido',
    cepInvalid: 'CEP inválido',
    cpfInvalid: 'CPF inválido',
    cnpjInvalid: 'CNPJ inválido',
    documentInvalid: 'Documento inválido',
    emailInvalid: 'E-mail inválido',
  },
  email: {
    label: 'E-mail',
    placeholder: 'seu@email.com',
  },
  password: {
    label: 'Senha',
    placeholder: '••••••••',
  },
  search: {
    clearLabel: 'Limpar busca',
  },
} as const
export default forms
